import { DollarSign, Users, Wrench } from 'lucide-react';

import type { FundFitToolSummary } from '@/types/service/internalAnalytics';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { formatCurrency, formatNumber } from '@/utils/saasDashboardHelpers';

interface FundFitToolStatsCardsProps {
  data: FundFitToolSummary;
}

const FundFitToolStatsCards = ({ data }: FundFitToolStatsCardsProps) => {
  const stats = [
    {
      title: 'Total Tool Calls',
      value: formatNumber(data.total_tool_calls),
      icon: Wrench,
      description: 'Tool invocations',
    },
    {
      title: 'Tool Cost',
      value: formatCurrency(parseFloat(data.total_tool_cost_usd)),
      icon: DollarSign,
      description: 'Total tool spend',
    },
    {
      title: 'Unique Tools',
      value: formatNumber(data.unique_tools),
      icon: Wrench,
      description: 'Distinct tools used',
    },
    {
      title: 'Tool Users',
      value: formatNumber(data.unique_users),
      icon: Users,
      description: `Across ${data.unique_organizations} organizations`,
    },
  ];

  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
      {stats.map((stat) => (
        <Card key={stat.title}>
          <CardHeader className='flex flex-row items-center justify-between pb-2'>
            <CardTitle className='text-sm font-medium text-muted-foreground'>
              {stat.title}
            </CardTitle>
            <stat.icon className='h-4 w-4 text-muted-foreground' />
          </CardHeader>
          <CardContent>
            <div className='text-2xl font-bold'>{stat.value}</div>
            <p className='text-xs text-muted-foreground'>{stat.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default FundFitToolStatsCards;
